import type { ErrorCode, FileRejection } from 'react-dropzone';

import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import { fData } from 'src/utils/format-number';

import { varAlpha } from 'src/theme/styles';

import { fileData } from '../../file-thumbnail';

// ----------------------------------------------------------------------

type Props = {
  files: FileRejection[];
};

const rejectionMessages: Record<ErrorCode, string> = {
  'file-too-large': 'Dosya boyutu çok büyük. Maksimum 10MB olmalıdır.',
  'file-invalid-type': 'Dosya türü geçersiz. Yalnızca resim dosyaları yüklenebilir.',
  'file-too-small': 'Dosya boyutu çok küçük. Minimum 1MB olmalıdır.',
  'too-many-files': 'En fazla 5 dosya yüklenebilir.',
};

export function RejectionFiles({ files }: Props) {
  if (!files.length) {
    return null;
  }

  return (
    <Paper
      variant="outlined"
      sx={{
        py: 1,
        px: 2,
        mt: 3,
        textAlign: 'left',
        borderStyle: 'dashed',
        borderColor: 'error.main',
        bgcolor: (theme) => varAlpha(theme.vars.palette.error.mainChannel, 0.08),
      }}
    >
      {files.map(({ file, errors }) => {
        const { path, size } = fileData(file);

        return (
          <Box key={path} sx={{ my: 1 }}>
            <Typography variant="subtitle2" noWrap>
              {path} - {size ? fData(size) : ''}
            </Typography>

            {errors.map((error) => (
              <Box key={error.code} component="span" sx={{ typography: 'caption' }}>
                - {rejectionMessages[error.code as ErrorCode] || error.message}
              </Box>
            ))}
          </Box>
        );
      })}
    </Paper>
  );
}
